import React,{useState} from 'react'
import "./Footer.css";
import {Link} from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import { db } from './firebase';
import { useStateValue } from './StateProvider';

function Footer() {
  const [{user},dispatch]=useStateValue();
  const [showModal, setShowModal] = useState(false);
  const [name,SetName]=useState('')
  const [feedback,setFeedback]=useState('')
  function handleClose() {
    setShowModal(false)
}
const submitFeed=()=>{
  if(user){
    db.collection('contactus')
  .doc(`${user.uid}`)
  .set({
    name:name,
    feedback:feedback
  })
  setShowModal(0)
  alert('Your feedback submitted.')
  }
  else{
    alert('Please Login to send feedback')
  }
}
    return (
      
      <article className="footer">
       <Modal
                show={showModal}
                onHide={handleClose}

            >
                <Modal.Header closeButton>
                    <Modal.Title>Contact Us</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <p><label className='text-bold'>Name : </label>  <input type='text' onChange={(e)=>{SetName(e.target.value)}}/></p>
                <p>FeedBack : </p>
                <textarea cols="55" onChange={(e)=>{setFeedback(e.target.value)}}></textarea>
                </Modal.Body>
                <Modal.Footer> 
                <Button onClick={submitFeed}>
                  Submit
                </Button>
                <Button onClick={()=>{
                    setShowModal(false)
                }}>Close</Button>                   
                </Modal.Footer>
            </Modal>
        <center><a href='#' className='backtotop text-white list-item'>Back to Top</a></center>
        <article className="d">

                <article className="col-md-4 mt-4 ">
                  <h5 className="text-white text-center">Get to know us</h5>
                  <ul className="list-unstyled text-center">
                      <li>
                        <a href="#!" className="text-white font-weight-light hoverF">About Us</a>
                      </li>
                      <li>
                        <a onClick={()=>{setShowModal(1)}} 
                        className="text-white font-weight-light hoverF hoversubmit">Contact Us</a>
                      </li>
                      <li>
                        <a href="#" className="text-white font-weight-light hoverF">SK's care</a>
                      </li>
                   </ul>
                </article>
                <article className="col-md-4 mt-4">
                  <h5 className="text-white text-center">Connect with us</h5>
                <ul className="list-unstyled text-center">
                      <li>
                        <a href="#"><i className="fab fa-facebook-square text-white hoverF "></i></a>
                      </li>
                      <li>
                        <a href="#!"><i className="fab fa-instagram text-white hoverF"></i></a>
                      </li>
                      <li>
                        <a href="#!"><i className="fab fa-twitter text-white hoverF"></i></a>
                      </li>
                      <li>
                        <a href="#!"><i className="fab fa-youtube text-white hoverF"></i></a>
                      </li>
                   </ul>
                </article>
                <article className="col-md-4 mt-4">
                <h5 className="text-white text-center">Let us help you</h5>
                  <ul className="list-unstyled text-center">
                      <li>
                        <a href="#!" className="text-white font-weight-light hoverF">COVID-19 and SK's</a>
                      </li>
                      <li>
                        <a href="#!" className="text-white font-weight-light hoverF">Your Account</a>
                      </li>
                      <li>
                        <a href="#!" className="text-white font-weight-light hoverF">SK's assistant download</a>
                      </li>
                      <li>
                        <a href="#!" className="text-white font-weight-light hoverF">help</a>
                      </li>
                   </ul>
                </article>
            </article><hr/>
            <article>
                 <article className="footer-copyright text-center text-white">© 2024 :&nbsp;
                   <span className="text-white">https://skgrocery.vercel.app</span>
                  </article><br/>
            </article>

      </article>
       
               

               
      
    )
}

export default Footer
